/* eslint-disable max-len */
import { Component } from 'react';

export default class ArrowComponent extends Component {
  render() {
    return (
      <svg
        className="arrow-component"
        id="Layer_1"
        x="0px"
        y="0px"
        width="20px"
        height="20px"
        viewBox="0 0 512 512"
        enableBackground="new 0 0 512 512"
      >
        <path xmlns="http://www.w3.org/2000/svg" d="M384.5,477.7c39.2-22.9,70.3-53.9,93.2-93.2C500.6,345.3,512,302.5,512,256c0-46.4-11.4-89.3-34.3-128.5   c-22.9-39.2-53.9-70.3-93.2-93.2C345.3,11.4,302.4,0,256,0c-46.4,0-89.3,11.4-128.5,34.3c-39.2,22.9-70.3,53.9-93.2,93.2   C11.4,166.7,0,209.6,0,256s11.4,89.3,34.3,128.5c22.9,39.2,53.9,70.3,93.2,93.2C166.7,500.6,209.6,512,256,512   C302.4,512,345.3,500.6,384.5,477.7z M209,422.3l-34-34c-4.2-4.2-6.3-9.2-6.3-15c0-5.8,2.1-10.8,6.3-15L277.3,256L175,153.7   c-4.2-4.2-6.3-9.2-6.3-15c0-5.8,2.1-10.8,6.3-15l34-34c4.2-4.2,9.2-6.3,15-6.3c5.8,0,10.8,2.1,15,6.3L390.3,241   c4.2,4.2,6.3,9.2,6.3,15s-2.1,10.8-6.3,15L239,422.3c-4.2,4.2-9.2,6.3-15,6.3C218.2,428.7,213.2,426.6,209,422.3z" />
        <div xmlns="http://www.w3.org/1999/xhtml" />
      </svg>
    );
  }
}
